import { MenuEntry } from '../../uikit'
import { status } from '../../uikit/widgets/Menu/config'
import { DOCS, TWITTER, TELEGRAM, GITHUB, MEDIUM } from '../../constants/links'
import i18next from '../../i18n'

const KCC_BRIDGE = 'https://kcc.io/bridge/transfer'


const PROD_MENU: MenuEntry[] = [
  {
    label: i18next.t('Home'),
    icon: 'HomeIcon',
    href: '/',
    ga: 'page_sidebar_home',
  },
  {
    label: i18next.t('Trade'),
    icon: 'Swap',
    items: [
      {
        href: '/swap',
        ga: 'page_sidebar_trade_swap',
        label: i18next.t('SWAP_12'),
      },
      {
        label: i18next.t('Liquidity'),
        href: '/pool',
        ga: 'page_sidebar_trade_liquidity',
      },
      {
        label: i18next.t('Rolling'),
        href: '/rolling',
        ga: 'page_sidebar_trade_rolling',
      },
      {
        label: i18next.t('Bridge'),
        href: KCC_BRIDGE,
        ga: 'page_sidebar_trade_bridge',
      },
    ],
  },
  {
    label: i18next.t('Bar'),
    icon: 'Bar',
    href: '/farm',
    ga: 'page_sidebar_bar',
    status: {
      text: 'New',
      color: 'tagNew',
    },
    items: [
      {
        label: i18next.t('Bar'),
        href: '/farm',
        ga: 'page_sidebar_trade_bar_v2',
      },
      {
        label: i18next.t('BarV1'),
        href: '/farmV1',
        ga: 'page_sidebar_bar_v1',
      },
    ],
  },
  {
    label: i18next.t('Wine Pools'),
    icon: 'Pool',
    href: '/pools',
    ga: 'page_sidebar_winepool',
    status: {
      text: 'New',
      color: 'tagNew',
    },
  },
  {
    label: i18next.t('Referral'),
    icon: 'Referral',
    href: '/referral',
    ga: 'page_sidebar_referral',
  },
  {
    label: i18next.t('Shaker'),
    icon: 'Shaker',
    href: '/minning',
    ga: 'page_sidebar_mining',
  },
  // {
  //   label: 'Exciting Product',
  //   icon: 'Question',
  //   href: 'https://t.me/MojitoFinance/56208',
  //   status: {
  //     text: 'Voting',
  //     color: 'primary',
  //   },
  // },
  {
    label: i18next.t('NFT'),
    icon: 'NftIcon',
    // status: {
    //   text: 'New',
    //   color: 'tagNew',
    // },
    items: [
      {
        href: '/nfts/profile',
        ga: 'page_sidebar_profile',
        label: i18next.t('Profile'),
      },
      {
        label: i18next.t('NFT Marketplace'),
        href: '/nfts',
        ga: 'page_sidebar_nft_marketplace',
        // status: status.NEW,
      },
    ],
  },
  {
    label: i18next.t('Launchpad'),
    icon: 'LaunchpadIcon',
    href: '/ido',
    status: status.HOT,
    // status: {
    //   text: 'New',
    //   color: 'tagNew',
    // }
  },
  {
    label: i18next.t('Bar Counter'),
    icon: 'BoxIcon',
    href: '/box',
    status: {
      text: 'New',
      color: 'tagNew',
    },
  },
  {
    label: i18next.t('Cocktail Tickets'),
    icon: 'Ticket',
    href: '/lottery',
    status: {
      text: 'New',
      color: 'tagNew',
    },
    ga: 'page_sidebar_CocktailTickets',
  },
  {
    label: i18next.t('Info'),
    icon: 'Info',
    href: 'https://info.mojitoswap.finance',
    ga: 'page_sidebar_Info',
  },
  {
    label: i18next.t('More'),
    icon: 'MoreIcon',
    items: [
      {
        label: i18next.t('Docs'),
        href: DOCS,
        ga: 'page_sidebar_More_docs',
      },
      {
        label: i18next.t('Medium'),
        href: MEDIUM,
        ga: 'page_sidebar_More_medium',
      },
      {
        label: i18next.t('Twitter'),
        href: TWITTER,
        ga: 'page_sidebar_More_Twitter',
      },
      {
        label: i18next.t('Telegram'),
        href: TELEGRAM,
        ga: 'page_sidebar_More_Telegram',
      },
      {
        label: i18next.t('Github'),
        href: GITHUB,
        ga: 'page_sidebar_More_Github',
      },
    ],
  },
]

const DEV_MENU: MenuEntry[] = [
  {
    label: i18next.t('Home'),
    icon: 'HomeIcon',
    href: '/',
  },
  {
    label: i18next.t('Trade'),
    icon: 'Swap',
    ga: 'page_sidebar_trade',
    items: [
      {
        label: i18next.t('SWAP_12'),
        href: '/swap',
      },
      {
        label: i18next.t('Liquidity'),
        href: '/pool',
      },
      {
        label: i18next.t('Rolling'),
        href: '/rolling',
      },
      {
        label: i18next.t('Bridge'),
        href: KCC_BRIDGE,
      },
    ],
    initialOpenState: true,
  },
  {
    label: i18next.t('Bar'),
    icon: 'Bar',

    items: [
      {
        label: 'Bar V2',
        href: '/farm',
        ga: 'page_sidebar_trade_liquidity',
      },
      {
        label: 'Bar V1',
        href: '/farmV1',
        ga: 'page_sidebar_trade_swap',
      },
    ],
    status: status.HOT,
  },
  {
    label: i18next.t('Wine Pools'),
    icon: 'Pool',
    href: '/pools',
    // status: status.HOT,
  },
  {
    label: i18next.t('Referral'),
    icon: 'Referral',
    href: '/referral',
    // status: status.NEW,
    ga: 'page_sidebar_referral',
  },
  {
    label: i18next.t('Shaker'),
    icon: 'Shaker',
    href: '/minning',
    // status: status.NEW,
    ga: 'page_sidebar_mining',
  },
  // {
  //   label: 'Exciting Product',
  //   icon: 'Question',
  //   href: 'https://t.me/MojitoFinance/56208',
  //   status: {
  //     text: 'Voting',
  //     color: 'primary',
  //   },
  // },
  // {
  //   label: 'Cocktail Tickets',
  //   icon: 'Ticket',
  //   href: '/tickets',
  //   // status: status.SOON,
  // },
  {
    label: i18next.t('Launchpad'),
    icon: 'LaunchpadIcon',
    href: '/ido',
    status: {
      text: 'New',
      color: 'primary',
    },
  },
  {
    label: i18next.t('NFT'),
    icon: 'NftIcon',
    status: {
      text: 'New',
      color: 'primary',
    },
    items: [
      {
        href: '/nfts/profile',
        ga: 'page_sidebar_profile',
        label: i18next.t('Profile'),
      },
      {
        label: i18next.t('NFT Marketplace'),
        href: '/nfts',
        ga: 'page_sidebar_nft_marketplace',
        // status: { text: status.SOON.text, color: 'warning' },
      },
    ],
  },
  {
    label: i18next.t('Bar Counter'),
    icon: 'BoxIcon',
    href: '/box',
    status: {
      text: 'New',
      color: 'primary',
    },
  },
  {
    label: i18next.t('Cocktail Tickets'),
    icon: 'Ticket',
    href: '/lottery',
    status: {
      text: 'New',
      color: 'tagNew',
    },
    ga: 'page_sidebar_CocktailTickets',
  },
  {
    label: i18next.t('Info'),
    icon: 'Info',
    href: '/info',
  },
  {
    label: i18next.t('More'),
    icon: 'MoreIcon',
    items: [
      {
        label: i18next.t('Docs'),
        href: DOCS,
      },
      {
        label: i18next.t('Medium'),
        href: MEDIUM,
        ga: 'page_sidebar_More_medium',
      },
      {
        label: i18next.t('Twitter'),
        href: TWITTER,
      },
      {
        label: i18next.t('Telegram'),
        href: TELEGRAM,
      },
      {
        label: i18next.t('Github'),
        href: GITHUB,
      },
    ],
  },
]

const config =
  process.env.REACT_APP_ENV_NAME === 'production-mainnet' || process.env.REACT_APP_ENV_NAME === 'preview'
    ? PROD_MENU
    : DEV_MENU

export default config
